// extracted by mini-css-extract-plugin
export var boldText = "_6i-4";
export var checkboxContainer = "_6i-6";
export var closeIcon = "_6i-i";
export var container = "_6i-0";
export var drawer = "_6i-8";
export var drawerContent = "_6i-9";
export var extraSmallText = "_6i-5";
export var fulfillmentGroupTable = "_6i-e";
export var largeText = "_6i-3";
export var loadingSpinnerContainer = "_6i-j";
export var mediumText = "_6i-2";
export var narrow = "_6i-f";
export var notificationLink = "_6i-l";
export var packageCheckIconContainer = "_6i-7";
export var slideoutHeaderActions = "_6i-g";
export var slideoutHeaderActionsShifted = "_6i-h";
export var slideoutHeaderContainer = "_6i-a";
export var slideoutModal = "_6i-c";
export var stickyHeaderWrapper = "_6i-b";
export var table = "_6i-k";
export var tableContainer = "_6i-d";
export var tertiaryText = "_6i-1";